import { apiFetch, noop, reportTo, run } from "../api";
import { selectSessionId } from "./app-slice";

const settingsPath = (groupId) => `/groups/${groupId}/notifications`;

export const loadNotificationSettings =
  (groupId, onSuccess = noop, onError = noop) =>
  (dispatch, getState) =>
    run(
      apiFetch(selectSessionId(getState()), settingsPath(groupId)),
      onSuccess,
      reportTo(onError, "Die Einstellungen konnten nicht geladen werden."),
    );

export const saveNotificationSettings =
  (groupId, settings, onSuccess = noop, onError = noop) =>
  (dispatch, getState) =>
    run(
      apiFetch(selectSessionId(getState()), settingsPath(groupId), {
        method: "PUT",
        body: {
          enabled: settings.enabled,
          only_involved: settings.only_involved,
        },
      }),
      onSuccess,
      reportTo(onError, "Die Einstellung konnte nicht gespeichert werden."),
    );
